const eventHub = new Vue();

// Distribute to components using global mixin
const eventHubMixin = {
    data: function () {
        return {
            eventHub: eventHub
        }
    }
}